import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../../IconV1'

export const Icon = styled(BaseIcon)`
  color: ${color.SILVER};
  animation: 0.5s iconFadeIn;

  ${p =>
    p.active &&
    `
    color: ${color.SCOOTER};
  `}

  @keyframes iconFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`
